import { NotificationProvider } from './../../providers/notification/notification';
import { AbsenceMotives } from './../../models/absence-motives';
import { PetitionTypes } from './../../models/petition-types';
import { PetitionProvider } from './../../providers/petition/petition';
import { UserProvider } from './../../providers/user/user';
import { AuthProvider } from './../../providers/auth/auth';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { GlobalVars } from './../../app/app.environment';

import { CalendarComponentOptions } from 'ion2-calendar'

@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
})
export class HomePage {

  dateMulti: string[] = [];
  optionsMulti: CalendarComponentOptions = {
    from: new Date(2000, 0),
    pickMode: 'multi',
    weekdays: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    weekStart: 1,
    monthFormat: 'MMMM YYYY',
    monthPickerFormat: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    daysConfig: [],
  };

  public alertaAreas;

  actualExtraHours;
  actualPendingHolidays;
  actualPendingAPs;

  private userSubscription;
  private petitionsSubscription;


  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public globalVars: GlobalVars,
    public authProvider: AuthProvider,
    public userProvider: UserProvider,
    public petitionProvider: PetitionProvider,
    public notificationProvider: NotificationProvider
  ) {
    this.getUserInfo();
    this.getPetitions();
    notificationProvider.initNotifications();
  }

  ionViewWillLeave() {
    if(this.userSubscription && !this.userSubscription.closed) this.userSubscription.unsubscribe();
    if(this.petitionsSubscription && !this.petitionsSubscription.closed) this.petitionsSubscription.unsubscribe();
  }

  getUserInfo() {
    this.userSubscription = this.userProvider.getUserData().subscribe(user => {
      if(user) {
        this.globalVars.user.extraHours = user.extraHours;
        this.globalVars.user.pendingAPs = user.pendingAPs;
        this.globalVars.user.pendingHolidays = user.pendingHolidays;
        this.globalVars.user.area = user.area;
        this.globalVars.user.areaId = user.areaId;
  
        this.actualExtraHours = this.globalVars.user.extraHours;
        this.actualPendingHolidays = this.globalVars.user.pendingHolidays ? this.globalVars.user.pendingHolidays[this.globalVars.currentPeriod] : null
        this.actualPendingAPs = this.globalVars.user.pendingAPs ? this.globalVars.user.pendingAPs[this.globalVars.currentPeriod] : null
    
        //if(this.globalVars.user.role == Role.admin) this.checkAreas();  
      }
    })
  }

  getPetitions() {
    this.petitionsSubscription = this.petitionProvider.getUserAcceptedCalendar().subscribe(petitions => {
      
      console.log(petitions)
      this.dateMulti = [];
      this.optionsMulti.daysConfig = [];

      petitions.forEach(petition => {
        if(petition.state == 'Aceptado' && petition.annulment == false) {
          console.log('omplir')
          this.addToCalendar(petition);
        }
  
        else if(petition.state == 'Aceptado' && petition.annulment == true) {
          console.log('buidar')
          this.removeFromCalendar(petition);
        }
      })
      
      console.log(this.dateMulti);
    })
  }

  addToCalendar(petition) {
    if (petition.typeId == PetitionTypes.hourCompensation || petition.motiveKey == AbsenceMotives.holidays) {
      var startDate = new Date(petition.beginDate);
      var endDate = new Date(petition.endDate);
    
      var curDate = startDate;
      while (curDate <= endDate) {
        /*
        let date = curDate.toLocaleDateString().split('/');
        date[1] = Number(date[1]) > 9 ? date[1] : 0 + date[1]; 
        this.dateMulti.push(date[2] + '-' + date[1] + '-' + date[0]);
        */
        
        this.dateMulti.push(curDate.toDateString());
        curDate.setDate(curDate.getDate() + 1);
      }
    }

    else this.dateMulti.push(petition.date);
  }

  removeFromCalendar(petition) {
    if (petition.typeId == PetitionTypes.hourCompensation || petition.motiveKey == AbsenceMotives.holidays) {
      var startDate = new Date(petition.beginDate);
      var endDate = new Date(petition.endDate);
    
      var curDate = startDate;
      while (curDate <= endDate) {
        this.dateMulti.splice(this.dateMulti.indexOf(petition.date),1);
        curDate.setDate(curDate.getDate() + 1);
      }
    }
    else {
      this.dateMulti.splice(this.dateMulti.indexOf(petition.date),1);
    }
  }

  /*
  checkAreas() {
    var errors = [];
    
    var ref = this.afDatabase.database.ref('repositoris/' + this.globalVars.repositori + '/areas/');
    ref.on('value', areas => {
      areas.forEach(area => {
        if(!area.val().caps) errors.push(area.key);
        return false;
      });

      console.log(errors);

      if(errors.length > 0) {

        var errorString = 'Faltan asignar encargados en las siguientes áreas: ';
  
        for(var i = 0; i < errors.length - 1; i++) errorString += errors[i] + ', ';
        if(errors[errors.length-1]) errorString += errors[errors.length-1];

        console.log(this.alertaAreas);
        if(this.alertaAreas == null) {
          this.alertaAreas = this.alertCtrl.create({
            title: 'Error en la comprovación de áreas.',
            subTitle: errorString,
            buttons: ['Dismiss']
          });

          console.log(this.alertaAreas);
          
          this.alertaAreas.present();
        }
       }
    });
  }
  */

  onSelect($event) {
    console.log('onSelect', $event);
  }

}




// WEBPACK FOOTER //
// ./src/pages/home/home.ts